import { CheckoutEvents } from '@mc/pre-paywall-events'
import { track, getPageSource } from '@mc/track-event'
import { Location, Vendor } from './data'

export const trackFlyoutViewed = () => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN, {
    action: 'viewed',
    location: Location.FLYOUT,
    page_source: getPageSource(),
    social_sign_on_vendor: Vendor.GOOGLE,
  })
}

export const trackFlyoutHidden = () => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN, {
    action: 'hidden',
    location: Location.FLYOUT,
    page_source: getPageSource(),
    social_sign_on_vendor: Vendor.GOOGLE,
  })
}

export const trackFlyoutTappedOutside = () => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN, {
    action: 'tap_outside',
    location: Location.FLYOUT,
    page_source: getPageSource(),
  })
}
